export type ValueOf<T> = T[keyof T];

/**
 * security context under which the guest application is running
 */
export enum SecurityContext {
  /**
   * application is using the same security context as the host
   */
  USER = 'USER',
  /**
   * application is using the partner security context
   */
  PARTNER = 'PARTNER',
}
